import {
  ERROR_MESSAGE_TIMEOUT,
  SUCCESS_MESSAGE_TIMEOUT,
} from '../util/TimeHelper';
import AssignmentHelper from '../util/AssignmentHelper';
import Log from '../logging/Log';
import MessagesController from './MessagesController';
import OperationController from './OperationController';
import OrderService from '../services/OrderService';
import StringHelper from '../util/StringHelper';
import assignmentStore from '../stores/assignmentStore';
import orderStore from '../stores/orderStore';

export const orderAssignmentOperationName = 'orderAssignment';

export default class OrderAssignmentController {
  static async startAssignment(): Promise<void> {
    assignmentStore.clearConfirmationMessages();
    const confirmationMessages =
      AssignmentHelper.determineAssignmentConfirmationMessages();
    if (confirmationMessages.length === 0) {
      // nothing for the user to confirm, so call confirm assignment
      await OrderAssignmentController.confirmAssignment();
    } else {
      // cause the confirmation dialog to popup
      Log.info(
        `Confirmation messages: [${confirmationMessages}]`,
        orderAssignmentOperationName
      );
      assignmentStore.setConfirmationMessages(confirmationMessages);
    }
  }

  static async confirmAssignment(): Promise<void> {
    OperationController.startOperation('Assigning transporter');
    const { selectedTransporterId, siteCode } =
      AssignmentHelper.getCommonAssignmentRequestFields();
    const orderIdInputs = AssignmentHelper.gatherOrderIdsForAssignment();
    const orderIds: string[] = orderIdInputs.map((o) => o.orderId);

    const assignmentResponse = await OrderService.assignOrdersToTransporter(
      siteCode,
      orderIdInputs,
      selectedTransporterId
    );
    OperationController.completeOperation();

    // gather the results and determine if need to inform user of any failures
    const successfulOrderIds: string[] = [];
    const failedOrderIds: string[] = [];
    const { errorMessage, successful, failed } = assignmentResponse;
    if (errorMessage) {
      failedOrderIds.push(...orderIds);
    } else {
      successfulOrderIds.push(...successful);
      failedOrderIds.push(...failed);
    }
    if (failedOrderIds.length > 0 && successfulOrderIds.length === 0) {
      const msg = `All assignments failed${
        errorMessage ? `: ${errorMessage}` : ''
      }`;
      MessagesController.addAlertMessage(msg, ERROR_MESSAGE_TIMEOUT);
      Log.error(msg, orderAssignmentOperationName);
    } else if (failedOrderIds.length > 0 && successfulOrderIds.length > 0) {
      const msg =
        'Partial order assignment failure: ' +
        `${StringHelper.makeCountDisplay(
          successfulOrderIds.length,
          'order'
        )} succeeded, but ` +
        `${StringHelper.makeCountDisplay(
          failedOrderIds.length,
          'order'
        )} failed.`;
      MessagesController.addAlertMessage(msg, ERROR_MESSAGE_TIMEOUT);
      Log.error(msg, orderAssignmentOperationName);
    }

    // remove the successful order ids from the selected order ids in case the user wants to try again with
    // just the failed order ids
    orderStore.removeSelectedOrderIds(successfulOrderIds);

    if (failedOrderIds.length === 0) {
      const msg = 'Successful assignment';
      MessagesController.addSuccessMessage(msg, SUCCESS_MESSAGE_TIMEOUT);
      Log.info(msg, orderAssignmentOperationName);
    }
  }
}
